import { Flex, Spin } from "antd";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/features/auth/AuthContext";

interface PrivateRouteProps {
  element: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Flex justify="center" align="center" style={{ height: "100vh" }}>
        <Spin size="large" />
      </Flex>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ tokenExpired: true }} replace />;
  }

  return <>{element}</>;
};

export default PrivateRoute;
